import api_config from '../../../api/config/_user'

export default {
    setResetPwdCode(data) {
        return new Promise((resolve, reject) => {
            api_config.setResetPwdCode(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    changePassword(data) {
        return new Promise((resolve, reject) => {
            api_config.changePassword(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}